import { DELIMITER } from "./delimiter";
export default {
    [DELIMITER.TAB]: "Табуляция",
    [DELIMITER.COMMA]: "Запятая",
    [DELIMITER.SEMICOLON]: "Точка с запятой",
    [DELIMITER.SPACE]: "Пробел"
};
